// extracted by mini-css-extract-plugin
module.exports = {"container":"m-","slide":"m_","show":"na"};